/**
 * af-collection.js — NADS April Fools Collection Page
 */
(function () {
  'use strict';

  var SWATCH_MAX = 8;
  var CDN = 'https://nadsunder.com/cdn/shop/files/';

  // Hex swatches
  var SWATCH_HEX = {
    'Black':         '#1A1A1A',
    'Navy':          '#0D245C',
    'Gray':          '#B6B5BB',
    'Undyed':        '#D9D1C9',
    'Natural':       '#D9D1C9',
    'Driftwood':     '#68594A',
    'Green':         '#5D703E',
    'Heather Gray':  '#C5C5C8',
    'Maroon':        '#6B1F1F',
    "Lover's Red":   '#D10000',
    'Holiday Red':   '#D10000',
    'Deep Blue':     '#5375B7'
  };

  // Image-based swatches — CDN files
  var SWATCH_IMG = {
    'Lucky NADS':    CDN + 'Lucky_NADS.jpg',
    'Multi':         CDN + 'multi.jpg',
    'USA':           CDN + 'usa-swatch.png',
    'Black/Navy':    CDN + 'Black_Navy.jpg',
    'Black/Gray':    CDN + 'Black_Gray.jpg',
    'Black/Undyed':  CDN + 'Black_Undyed.jpg'
  };

  function getSwatchStyle(colorName) {
    if (!colorName) return { backgroundColor: '#ccc' };
    if (SWATCH_IMG[colorName]) {
      return {
        backgroundImage: 'url(' + SWATCH_IMG[colorName] + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
    }
    if (SWATCH_HEX[colorName]) return { backgroundColor: SWATCH_HEX[colorName] };
    // Fallback: try splitting X/Y for unknown combinations
    if (colorName.indexOf('/') !== -1) {
      var parts = colorName.split('/');
      var ca = SWATCH_HEX[parts[0].trim()] || '#ccc';
      var cb = SWATCH_HEX[parts[1].trim()] || '#999';
      return { background: 'linear-gradient(135deg,' + ca + ' 50%,' + cb + ' 50%)' };
    }
    return { backgroundColor: '#ccc' };
  }

  function openDraw() {
    if (typeof openCartDrawer === 'function') { openCartDrawer(); return; }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('product:added'));
    var cartIcon = document.querySelector('[data-drawer-id="sidebar-cart"]');
    if (cartIcon) cartIcon.click();
  }

  function addToCart(variantId, onSuccess, onError) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(r) {
      if (!r.ok) throw new Error('Cart error ' + r.status);
      return r.json();
    }).then(onSuccess).catch(onError);
  }

  function initCard(card) {
    if (card.dataset.afInit) return;
    card.dataset.afInit = '1';

    var jsonEl = card.querySelector('.af-variants-data');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent.trim()); }
    catch(e) { console.warn('[af] JSON parse error', e); return; }
    if (!variants || !variants.length) return;

    var colors = [], sizes = [], seenC = {}, seenS = {};
    variants.forEach(function(v) {
      if (v.color && !seenC[v.color]) { seenC[v.color] = true; colors.push(v.color); }
      if (v.size  && !seenS[v.size])  { seenS[v.size]  = true; sizes.push(v.size); }
    });

    var colorImages = {};
    variants.forEach(function(v) {
      if (v.color && !colorImages[v.color] && v.image) {
        colorImages[v.color] = v.image.indexOf('//') === 0 ? 'https:' + v.image : v.image;
      }
    });

    // Preload all color images so swatch clicks feel instant
    Object.keys(colorImages).forEach(function(color) {
      var preload = new Image();
      preload.src = colorImages[color];
    });

    var imgEl      = card.querySelector('.af-card__image');
    var swatchesEl = card.querySelector('.af-card__swatches');
    var overlay    = card.querySelector('.af-card__size-overlay');
    var sizeBtnsEl = card.querySelector('.af-card__size-buttons');
    var atcBtn     = card.querySelector('.af-card__atc-btn');
    var colorLabel = card.querySelector('.af-card__selected-color');
    var imageWrap  = card.querySelector('.af-card__image-wrap');
    var productUrl = card.dataset.productUrl || '';

    if (!overlay) return;

    var selectedColor = colors[0] || null;
    var selectedSize  = null;

    if (imgEl && selectedColor && colorImages[selectedColor]) {
      imgEl.src = colorImages[selectedColor];
    }

    // Swatches (capped at SWATCH_MAX)
    colors.forEach(function(color, idx) {
      if (idx >= SWATCH_MAX) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'af-swatch' + (color === selectedColor ? ' is-active' : '');
      btn.title = color;
      btn.setAttribute('aria-label', color);
      Object.assign(btn.style, getSwatchStyle(color));
      btn.addEventListener('click', function(e) { e.stopPropagation(); selectColor(color); });
      swatchesEl.appendChild(btn);
    });

    if (colors.length > SWATCH_MAX) {
      var overflow = document.createElement('span');
      overflow.className = 'af-swatch-overflow';
      overflow.textContent = '+' + (colors.length - SWATCH_MAX);
      swatchesEl.appendChild(overflow);
    }

    // Size buttons
    sizes.forEach(function(size) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'af-size-btn';
      btn.dataset.size = size;
      var anyAvail = variants.some(function(v) { return v.size === size && v.available; });
      if (!anyAvail) btn.classList.add('is-unavailable');
      btn.textContent = abbreviateSize(size);
      btn.title = size;
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (btn.classList.contains('is-unavailable')) return;
        selectSize(size, btn);
      });
      sizeBtnsEl.appendChild(btn);
    });

    // Image click → PDP
    if (imageWrap) {
      imageWrap.addEventListener('click', function(e) {
        if (e.target.closest('.af-card__size-overlay')) return;
        var variant = selectedSize
          ? findVariant(selectedColor, selectedSize)
          : variants.find(function(v) { return v.color === selectedColor && v.available; }) || variants[0];
        var url = productUrl + (variant ? '?variant=' + variant.id : '');
        if (url) window.location.href = url;
      });
      imageWrap.addEventListener('mouseenter', function() {
        overlay.classList.add('is-visible');
        overlay.setAttribute('aria-hidden', 'false');
      });
    }

    card.addEventListener('mouseleave', function() { resetCard(); });
    document.addEventListener('click', function(e) { if (!card.contains(e.target)) resetCard(); });

    if (atcBtn) {
      atcBtn.hidden = true;
      atcBtn.setAttribute('aria-hidden', 'true');
      atcBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var variant = findVariant(selectedColor, selectedSize);
        if (!variant || !variant.available) return;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding\u2026';
        addToCart(variant.id, function() {
          atcBtn.textContent = 'Added \u2713';
          openDraw();
          setTimeout(function() {
            resetCard();
            atcBtn.textContent = 'Add to Cart';
            atcBtn.disabled = false;
          }, 2200);
        }, function() {
          atcBtn.textContent = 'Try Again';
          atcBtn.disabled = false;
        });
      });
    }

    function selectColor(color) {
      selectedColor = color;
      [].forEach.call(swatchesEl.querySelectorAll('.af-swatch'), function(s) {
        s.classList.toggle('is-active', s.title === color);
      });
      if (colorLabel) colorLabel.textContent = color;
      if (imgEl && colorImages[color]) imgEl.src = colorImages[color];
      if (selectedSize) updateAtcState();
    }

    function selectSize(size, btn) {
      selectedSize = size;
      [].forEach.call(sizeBtnsEl.querySelectorAll('.af-size-btn'), function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      overlay.classList.add('is-visible', 'has-size');
      overlay.setAttribute('aria-hidden', 'false');
      if (atcBtn) { atcBtn.hidden = false; atcBtn.setAttribute('aria-hidden', 'false'); }
      updateAtcState();
    }

    function updateAtcState() {
      if (!atcBtn) return;
      var variant = findVariant(selectedColor, selectedSize);
      atcBtn.textContent = (variant && !variant.available) ? 'Sold Out' : 'Add to Cart';
      atcBtn.disabled = !!(variant && !variant.available);
    }

    function resetCard() {
      selectedSize = null;
      [].forEach.call(sizeBtnsEl.querySelectorAll('.af-size-btn'), function(b) { b.classList.remove('is-active'); });
      overlay.classList.remove('is-visible', 'has-size');
      overlay.setAttribute('aria-hidden', 'true');
      if (atcBtn) { atcBtn.hidden = true; atcBtn.setAttribute('aria-hidden', 'true'); }
    }

    function findVariant(color, size) {
      return variants.find(function(v) { return v.color === color && v.size === size; }) || null;
    }
  }

  function abbreviateSize(size) {
    var map = { 'Small':'S','Medium':'M','Large':'L','Extra Large':'XL','X-Large':'XL','XX-Large':'XXL','XXL':'XXL','XL':'XL' };
    return map[size] || size;
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('.af-card'), initCard);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
